export function getLocalizedName(
  record: any,
  locale: string,
  field = 'name'
): string {
  if (!record) return '';
  if (locale === 'en') {
    const enField = `${field}_en`;
    const en = record[enField];
    if (en && String(en).trim()) return String(en).trim();
  }
  return record[field] ?? record.code ?? record.id ?? '';
}

export function getLocalizedField(
  record: any,
  locale: string,
  cnField: string,
  enField: string
): string {
  if (!record) return '';
  if (locale === 'en') {
    const en = record[enField];
    if (en && String(en).trim()) return String(en).trim();
  }
  return record[cnField] ?? record.code ?? record.id ?? '';
}
